import * as React from 'react';

export interface PaymentIconProps {
  className?: string;
  company: string;
}

const getPath = (company: string) => {
  switch (company) {
    case 'google':
      return (
        <g>
          <g>
            <path
              fill="#3C4043"
              d="M56 22.9v13.9H51.6V2.5h11.7c3 0 5.5 1 7.6 3C72.9 7.4 74 9.8 74 12.7c0 2.9-1.1 5.3-3.2 7.3 -2 2-4.6 2.9-7.5 2.9h-7.3V22.9zM56 6.7v11.9h7.4c1.7 0 3.2-0.6 4.4-1.8 1.2-1.2 1.8-2.6 1.8-4.2 0-1.6-0.6-3-1.8-4.1 -1.1-1.2-2.6-1.8-4.4-1.8h-7.4V6.7z"
            />
            <path
              fill="#3C4043"
              d="M85.5 12.5c3.3 0 5.8 0.9 7.7 2.6 1.9 1.7 2.8 4.1 2.8 7.2v14.4h-4.2v-3.2h-0.2c-1.8 2.7-4.2 4-7.3 4 -2.6 0-4.7-0.8-6.5-2.3s-2.6-3.4-2.6-5.7c0-2.4 0.9-4.3 2.8-5.8 1.8-1.4 4.3-2.1 7.3-2.1 2.6 0 4.8 0.5 6.5 1.4v-1c0-1.5-0.6-2.8-1.8-3.9 -1.2-1.1-2.6-1.6-4.3-1.6 -2.5 0-4.4 1-5.8 3.1l-3.9-2.4C78.2 14.1 81.3 12.5 85.5 12.5zM79.8 29.5c0 1.2 0.5 2.1 1.5 2.9 1 0.8 2.1 1.2 3.4 1.2 1.9 0 3.5-0.7 5-2.1 1.5-1.4 2.2-3 2.2-4.8 -1.4-1.1-3.3-1.6-5.7-1.6 -1.8 0-3.3 0.4-4.5 1.3C80.4 27.2 79.8 28.3 79.8 29.5z"
            />
            <path
              fill="#3C4043"
              d="M120 13.3L105.3 47h-4.5l5.5-11.8 -9.7-21.9h4.8l7 16.8h0.1l6.8-16.8H120z"
            />
          </g>
          <g>
            <path
              fill="#4285F4"
              d="M38.5 20.1c0-1.4-0.1-2.8-0.4-4.1H19.7v7.6l10.6 0c-0.4 2.5-1.8 4.7-3.9 6.1v4.9h6.3C36.4 31.1 38.5 26 38.5 20.1z"
            />
            <path
              fill="#34A853"
              d="M26.3 29.6c-1.8 1.2-4 1.9-6.7 1.9 -5.1 0-9.5-3.4-11-8.1H2.1v5.1c3.2 6.4 9.9 10.8 17.6 10.8 5.3 0 9.8-1.7 13-4.7L26.3 29.6z"
            />
            <path
              fill="#FABB05"
              d="M8 19.6c0-1.3 0.2-2.6 0.6-3.7v-5.1H2.1C0.8 13.5 0 16.5 0 19.6s0.8 6.2 2.1 8.8l6.5-5.1C8.2 22.2 8 20.9 8 19.6z"
            />
            <path
              fill="#E94235"
              d="M19.7 7.8c2.9 0 5.5 1 7.5 2.9l5.6-5.6C29.4 1.9 25 0 19.7 0 12 0 5.3 4.4 2.1 10.8l6.5 5.1C10.2 11.2 14.5 7.8 19.7 7.8z"
            />
          </g>
        </g>
      );
    case 'apple':
      return (
        <g>
          <path d="M22.7 6.6C24.1 4.8 25.1 2.4 24.8 0c-2.1 0.1-4.6 1.4-6 3.1 -1.3 1.5-2.5 4-2.2 6.3C18.9 9.7 21.2 8.3 22.7 6.6" />
          <path d="M24.8 9.9c-3.4-0.2-6.2 1.9-7.8 1.9 -1.6 0-4.1-1.8-6.7-1.8 -3.5 0.1-6.7 2-8.4 5.1 -3.6 6.3-1 15.5 2.6 20.6 1.7 2.5 3.8 5.3 6.5 5.2 2.6-0.1 3.6-1.7 6.7-1.7 3.1 0 4 1.7 6.7 1.6 2.8 0 4.6-2.5 6.3-5 2-2.9 2.8-5.6 2.8-5.8 0 0-5.4-2.1-5.5-8.3 0-5.2 4.2-7.7 4.4-7.8C29.9 10.4 26.1 10 24.8 9.9" />
          <path d="M54.1 2.9c7.3 0 12.4 5.1 12.4 12.4 0 7.4-5.2 12.5-12.6 12.5h-8.1v12.9h-5.9V2.9L54.1 2.9 54.1 2.9zM45.8 22.9h6.7c5.1 0 8-2.7 8-7.5 0-4.8-2.9-7.5-8-7.5h-6.7V22.9z" />
          <path d="M68.1 32.9c0-4.8 3.7-7.8 10.2-8.1l7.5-0.4v-2.1c0-3.1-2.1-4.9-5.5-4.9 -3.3 0-5.3 1.6-5.8 4h-5.3c0.3-5 4.6-8.6 11.4-8.6 6.7 0 10.9 3.5 10.9 9.1v19h-5.4v-4.5h-0.1c-1.6 3.1-5.1 5-8.7 5C71.9 41.2 68.1 37.8 68.1 32.9zM85.9 30.4v-2.2l-6.8 0.4c-3.4 0.2-5.3 1.7-5.3 4.1 0 2.4 2 4 5 4C82.8 36.7 85.9 34 85.9 30.4z" />
          <path d="M96.6 50.9v-4.6c0.4 0.1 1.4 0.1 1.8 0.1 2.6 0 4-1.1 4.9-3.9 0 0 0.5-1.7 0.5-1.7l-9.9-27.6H100l7 22.5h0.1l7-22.4H120l-10.3 29c-2.3 6.7-5.1 8.8-10.8 8.8C98.4 51 97 51 96.6 50.9z" />
        </g>
      );
    default:
      return <path />;
  }
};

export const PaymentIcon: React.FC<PaymentIconProps> = (props) => (
  <svg
    x="0"
    y="0"
    width="120"
    height="51"
    viewBox="0 0 120 51"
    className={props.className}
  >
    {getPath(props.company)}
  </svg>
);

export default PaymentIcon;
